import { api } from '../../Controllers/api'

const requestDrivers = () => {
  return {
    type: 'REQUEST_DRIVERS',
    loading: true
  }
}

const receiveDrivers = data => {
  return {
    type: 'RECEIVE_DRIVERS',
    payload: { data },
    loading: false
  }
}

const getDrivers = isRefresh => {
  return dispatch => {
    if (!isRefresh) {
      dispatch(requestDrivers())
    }
    api.get(`companyDrivers`).then(({ data }) => {
      dispatch(receiveDrivers(data))
    })
  }
}
export { getDrivers }
